export default {
  ROLE: "We'll use your role to create an onboarding experience just for you.",
  EMAIL_VOLUME: "We'll use your monthly email volume to optimize your email plan.",
  COMPANY_INFO: 'Knowing your business size helps us develop better products for you in the future.',
};
